import { Drawer } from "@/components";
import FormCreate from "./FormCreate";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const RoomCreateDrawer = ({ open, setOpen }: Props) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      label="新しいチャットを作成する"
      description={`事前相談はこちらから。事務局で確認した後、ご連絡します。\n（平日の9:00-17:00まで。それ以外の日時では回答が翌営業日以降になることがあります）`}
      size="large"
      disableBackdropClick
    >
      <FormCreate onClose={handleClose} />
    </Drawer>
  );
};

export default RoomCreateDrawer;
